export const ClientsStatus = {
  Active: 'active',
  AwaitingStart: 'awaiting_start'
} as const;

export type ClientsStatus = (typeof ClientsStatus)[keyof typeof ClientsStatus];

export const ClientPlanStatus = {
  Enrolling: 'enrolling',
  AwaitingStart: 'awaiting_start',
  Active: 'active'
} as const;

export type ClientPlanStatus = (typeof ClientPlanStatus)[keyof typeof ClientPlanStatus];

export type ClientType = 'company' | 'person';

export type ClientsColumnId = 'company' | 'companySize' | 'industry' | 'location' | 'enrollmentWindow';

export type ClientsSortKey = 'recency' | 'companyName' | 'workforceSize' | 'enrollmentWindow';

export const ClientContactType = {
  Administrator: 'administrator',
  PaymentManager: 'payment manager',
  CommercialContact: 'commercial contact',
  SponsorAdmin: 'sponsor admin',
  Seller: 'seller'
} as const;

export type ClientContactType = (typeof ClientContactType)[keyof typeof ClientContactType];

export type ClientContactSource = 'client' | 'contract';
